import { standardGetQuery, streamGetQuery } from "./apiUtils.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Function for performing a keyword search query.
 */
export const queryKeyword = (props, options = {}, callback = null) => {
    let path = Constants.API_SEARCH_KEYWORD + `?query=${encodeURIComponent(options.keywordQuery)}`;

    if (options.keywordTable) path += `&table=${options.keywordTable.toLowerCase()}`;
    if (options.keywordLimit) path += `&limit=${options.keywordLimit}`;
    if (options.keywordThreshold) path += `&threshold=${options.keywordThreshold}`;

    standardGetQuery(props, path, (response) => {
        const states = props.search;
        states.setKeywordResult(response.body);

        if (callback) callback(response);
    });
};

/**
 * Function for performing a semantic (chatbot) search query.
 *
 * Sent as a POST with a JSON body so it can carry structured conversation history.
 * History is only meaningful for new turns (page 0); the backend ignores it on pagination.
 */
export const querySemantic = (props, options = {}, callback = null, finalCallback = null) => {
    const path = Constants.API_SEARCH_SEMANTIC;

    const body = {
        query: options.semanticQuery,
        page: options.semanticPage || 0,
        limit: options.semanticLimit,
        threshold: options.semanticThreshold,
        max_results_per_resource: options.semanticMaxResultsPerResource,
        min_duration_between_results: options.semanticMinDurationBetweenResults,
        history: options.semanticHistoryPayload || [],
        library_ids: options.semanticLibraryIds || []
    };

    streamGetQuery(props, path, callback, finalCallback, { method: "POST", body });
};
